import { mapValues as _mapValues, omit as _omit } from 'lodash'

export default class MultiCurrency {
  constructor ({ converted = {}, ...currencies } = {}) {
    this.converted = this.toNumber(converted)

    Object.assign(this, this.toNumber(currencies))

    return new Proxy(this, {
      get (target, prop) {
        if (prop in target.converted) return target.converted[prop]

        return target[prop]
      }
    })
  }

  get currencies () {
    return _omit(this, ['converted'])
  }

  get currency () {
    return Object.keys(this.currencies).find(currency => currency)
  }

  get value () {
    return this.currencies[this.currency] || 0
  }

  get is_zero () {
    return !Object.keys(this.currencies).length || Object.values(this.currencies).every(amount => !amount)
  }

  set is_zero (value) {
    if (value) Object.keys(this.currencies).forEach(key => this[key] = 0)
  }

  get to_database () {
    return this.currencies
  }

  toNumber (currencies = {}) {
    return _mapValues(currencies, amount => Number(amount))
  }

  isConverted (currency) {
    return !this.currencies.hasOwnProperty(currency)
  }
}